import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"margin":"20px auto"} }
const _hoisted_2 = {
  class: "t6_table_b",
  style: {"margin-bottom":"48px"}
}

import { reactive, toRefs } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'item-list',
  props: {
    itemList:[] as any
},
  setup(__props) {

const props = __props
const { itemList } = toRefs(props)



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _cache[0] || (_cache[0] = _createElementVNode("tr", null, [
          _createElementVNode("th", null, "事项名称"),
          _createElementVNode("th", { width: "300" }, "所属部门")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemList), (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(item.serviceName), 1),
            _createElementVNode("td", null, _toDisplayString(item.deptName), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})